import { render, staticRenderFns } from "./AccountProfileSettingsAddAddress.vue?vue&type=template&id=0aa8a462&"
import script from "./AccountProfileSettingsAddAddress.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettingsAddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports